// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tyLzC7u3U6sd0QCR{text-align:center}.I_vOgYH8fgCD1BXJ{height:116px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"completeHeader": `tyLzC7u3U6sd0QCR`,
	"messageContainer": `I_vOgYH8fgCD1BXJ`
};
export default ___CSS_LOADER_EXPORT___;
